import useAllLabelsMutations from "features/labels/datahooks/useAllLabelsMutations";

import { Button } from "common/components/ui/Button";
import { DialogDescription, DialogTitle } from "common/components/ui/Dialog";
import { DrawerDescription, DrawerTitle } from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import type { LabelType } from "../../types";

export default function DeleteLabel({
  labelType,
  labelId,
  onBack,
}: {
  labelId: string;
  onBack: () => void;
  labelType: LabelType;
}) {
  const isDesktop = useTwBreakpoint("lg");

  const { deleteLabel, isDeletingLabel } = useAllLabelsMutations(labelType);

  function onDelete() {
    deleteLabel({ labelId }).then(() => {
      onBack();
    });
  }

  const Title = isDesktop ? DialogTitle : DrawerTitle;
  const Description = isDesktop ? DialogDescription : DrawerDescription;

  return (
    <>
      <Title>Delete label</Title>
      <Description className="mb-8 lg:mb-12">
        Deleting this label will remove it from all {labelType.toLowerCase()}s
        it is currently applied to. This cannot be changed later. Are you sure
        you want to proceed?
      </Description>

      <div className="flex justify-between gap-x-2.5">
        <Button
          onClick={onBack}
          variant="secondary-black"
          className="lg:flex-1"
          disabled={isDeletingLabel}
        >
          Cancel
        </Button>

        <Button
          onClick={onDelete}
          variant="outline-danger"
          className="lg:flex-1"
          isLoading={isDeletingLabel}
          data-cy="delete-label-button"
        >
          Delete
        </Button>
      </div>
    </>
  );
}
